import React, { useState } from "react";

import { useMutation } from "@tanstack/react-query";

import { notifyError, notifySuccess } from "@/api/toastBus";
import { apiClient } from "@/api/client";

import { Button } from "./Button";
import { Modal } from "./Modal";

const formatErr = (e: unknown) => (e instanceof Error ? e.message : "Ошибка");

interface ChangePasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ChangePasswordModal({ isOpen, onClose }: ChangePasswordModalProps) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");

  const mutation = useMutation({
    mutationFn: (pwd: string) => apiClient.changeMyPassword(pwd),
    onError: (e: unknown) => {
      notifyError(`Не удалось сменить пароль: ${formatErr(e)}`);
    },
    onSuccess: () => {
      notifySuccess("Пароль обновлён");
      setPassword("");
      setConfirm("");
      onClose();
    },
  });

  const handleClose = () => {
    if (mutation.isPending) return;
    setPassword("");
    setConfirm("");
    onClose();
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!password) {
      notifyError("Введите новый пароль");
      return;
    }
    if (password !== confirm) {
      notifyError("Пароли не совпадают");
      return;
    }
    mutation.mutate(password);
  };

  return (
    <Modal onClose={handleClose} title="Смена пароля" isOpen={isOpen} size="small">
      <form className="space-y-4" onSubmit={handleSubmit}>
        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700" htmlFor="new-pwd">
            Новый пароль
          </label>
          <input
            className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-purple-500"
            onChange={e => setPassword(e.target.value)}
            disabled={mutation.isPending}
            autoComplete="new-password"
            value={password}
            type="password"
            id="new-pwd"
          />
        </div>
        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700" htmlFor="confirm-pwd">
            Повторите пароль
          </label>
          <input
            className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-purple-500"
            onChange={e => setConfirm(e.target.value)}
            disabled={mutation.isPending}
            autoComplete="new-password"
            id="confirm-pwd"
            type="password"
            value={confirm}
          />
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button
            disabled={mutation.isPending}
            onClick={handleClose}
            variant="secondary"
            type="button"
          >
            Отмена
          </Button>
          <Button disabled={mutation.isPending} variant="primary" type="submit">
            {mutation.isPending ? "Сохранение..." : "Сохранить"}
          </Button>
        </div>
      </form>
    </Modal>
  );
}
